import crypto from 'crypto-js';
import cookies from 'js-cookie';
import secrets from '../../../helpers/secrets';
import parseParams from '../../../helpers/parse-parameters';

// Delete unecrypted cookies with personal information
function removeCookies() {
  cookies.remove('_mkto_lead_email');
  cookies.remove('_mkto_lead_firstName');
  cookies.remove('_mkto_lead_lastName');
  cookies.remove('_mkto_lead_phone');
  cookies.remove('_sk_leadInfo');
}

function getLeadInfoFromCookie() {
  const encrypted = cookies.get('_sk_leadInfo_2');
  if (!encrypted) {
    return {};
  }
  const decrypted = crypto.AES.decrypt(
    encrypted.toString(),
    secrets.marketoLeadInfo
  );
  return JSON.parse(decrypted.toString(crypto.enc.Utf8));
}

function getPrefillValuesFromQueryParams(queryParamPrefill) {
  if (!queryParamPrefill) {
    return {};
  }
  const queryParams = parseParams(window.location.search);
  return Object.keys(queryParamPrefill).reduce(
    (formPrefillValues, prefillKey) => {
      if (prefillKey in queryParams) {
        formPrefillValues[queryParamPrefill[prefillKey]] =
          queryParams[prefillKey];
      }
      return formPrefillValues;
    },
    {}
  );
}

function init(form, queryParamPrefill) {
  removeCookies();
  // Description for form 1725:
  // Leads submitting leads or merchants submitting leads. These are non-partner/channel referrals. 4/25/17 - Added Lead Submission URL (hidden field) 4/25/17 - Added SK Country Code (hidden field)
  // referral forms should not be prefilled since user is entering someone else's contact info
  // not sure if still needed since id is not found elsewhere in code, but might be in database
  if (form.getId() === 1725) return;
  // don't prefill forms that have Partner_Email__c field,
  // such as on /partners/lead
  if (form.vals().Partner_Email__c !== undefined) return;
  const leadInfo = getLeadInfoFromCookie();
  const queryParamValues = getPrefillValuesFromQueryParams(queryParamPrefill);
  const mergedPrefillValues = Object.assign({}, leadInfo, queryParamValues);
  form.vals(mergedPrefillValues);
}

export default {
  init
};
